import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/50 pt-16 md:pt-20 pb-8">
      <div className="px-4 md:px-6 lg:px-10">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-foreground-950 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-database-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl whitespace-nowrap">Kakobuy Hub</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your ultimate resource for organized product discovery. Browse thousands of curated finds across 14 categories with the Kakobuy Spreadsheet database.
            </p>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm uppercase tracking-wider mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {['Shoes', 'Hoodies / Sweaters', 'T-Shirts', 'Jackets', 'Pants / Shorts', 'Headwear'].map((cat) => (
                <li key={cat}>
                  <a
                    href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Categories */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm uppercase tracking-wider mb-4">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {['Sets', 'Underwear', 'Jersey', 'Accessories', 'Bags', 'Belts', 'Perfumes', 'Other Stuff'].map((cat) => (
                <li key={cat}>
                  <a
                    href="https://kaspreadsheet.com/search-913/name/Shoes.html"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading font-semibold text-foreground-900 text-sm uppercase tracking-wider mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/kakobuy-spreadsheet-ultimate-guide-2026" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  Complete Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  Main Website
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-300/60 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500 justify-center sm:justify-start">
            <span>&copy; {new Date().getFullYear()} Kakobuy Hub. All rights reserved.</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              Main Site
            </a>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
              aria-label="Visit main website"
            >
              <i className="ri-external-link-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
              aria-label="Go to Kakobuy Spreadsheet"
            >
              <i className="ri-shopping-bag-3-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}